module.exports = __webpack_public_path__ + "media/unipod/first_phase_plumbing-80ab0863.jpg";